import type { FunctionComponent } from "react";
import type { RecordJobData } from "@smartsuite/automation-engine-api";
import { ActivityDetailsTriggerGroup } from "../ActivityDetailsTriggerGroup/ActivityDetailsTriggerGroup";
import { ActivityDetailsItem } from "../ActivityDetailsItem/ActivityDetailsItem";
import { RECORD_ID } from "../../../../../utils/constants";
import {
  addEmptyValueIfNeeded,
  findRecordValue,
} from "../../../ActivityGrid/ActivityGrid.helpers";
import { valueDataToString } from "@smartsuite/automation-conditions";

export const GeneralPdfGroupWrapper: FunctionComponent<{
  index: number;
  recordJob?: RecordJobData;
  recordJodId?: string;
  onDetailsClickWithFetch?: (recordJodId: string) => Promise<void>;
  onDetailsClick?: () => void;
}> = ({
  index,
  recordJob,
  onDetailsClickWithFetch,
  onDetailsClick,
  recordJodId,
}) => {
  const record =
    recordJob?.outputData?.recordList?.recordList !== undefined
      ? recordJob?.outputData?.recordList.recordList.records[0]
      : recordJob?.record;

  const output = record?.outputs.find(
    (output) => output.outputId === RECORD_ID,
  );

  const titleOutput = recordJob?.outputData?.outputs.find(
    (output) => output.outputId === "exported-pdf-title",
  );

  const linkOutput = recordJob?.outputData?.outputs.find(
    (output) => output.outputId === "exported-pdf-url",
  );

  let title = recordJob === undefined ? "" : "<no value>";
  if (titleOutput !== undefined) {
    title = valueDataToString(titleOutput.value);
  }

  let link: string | undefined;
  if (linkOutput !== undefined) {
    link = valueDataToString(linkOutput.value);
  }

  return (
    <ActivityDetailsTriggerGroup
      title={`Record ${index + 1}`}
      onClick={() => {
        if (
          onDetailsClickWithFetch !== undefined &&
          recordJodId !== undefined
        ) {
          void onDetailsClickWithFetch(recordJodId);
        }
        if (onDetailsClick !== undefined) {
          onDetailsClick();
        }
      }}
    >
      <ActivityDetailsItem label="Pdf Document">
        {link ? (
          <a href={link} target="_blank" rel="noreferrer">
            {title}
          </a>
        ) : (
          <span>{title}</span>
        )}
      </ActivityDetailsItem>
      {output !== undefined && (
        <ActivityDetailsItem label={output.outputLabel}>
          {addEmptyValueIfNeeded(findRecordValue(output.outputId, record))}
        </ActivityDetailsItem>
      )}
    </ActivityDetailsTriggerGroup>
  );
};
